import { Injectable, ApplicationRef } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';
import { BrowserDetectorService } from './browser-detector.service';

@Injectable({
  providedIn: 'root'
})
export class PwaService {

  promptEvent: any;

  constructor(private appRef: ApplicationRef,
              private browserDetectorService: BrowserDetectorService,
              //private modalService: BsModalService,
              private swUpdate: SwUpdate,) {

    console.log('PwaService');


    let isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);
    console.log(isInWebAppChrome);

    if(!isInWebAppChrome && this.browserDetectorService.browser!.isMobile && !this.browserDetectorService.browser!.isIOS ){
      window.addEventListener('beforeinstallprompt', event => {

          event.preventDefault();
          this.promptEvent = event;
          console.log(this.promptEvent);
      });
    }else if(this.browserDetectorService.browser!.isMobile && !this.browserDetectorService.browser!.isIOSStandalone && this.browserDetectorService.browser!.isIOS){
      //this.modalService.show(ModalIosComponent);

    }

    console.log(swUpdate.isEnabled);
    if (this.swUpdate.isEnabled) {
      swUpdate.checkForUpdate();
      const appIsStable$ = appRef.isStable.pipe(first(isStable => {
        console.log(`App is Stable: ${isStable}`);
        return isStable === true;
      }));
      const everySixHours$ = interval(6 * 60 * 60 * 1000);
      const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

      everySixHoursOnceAppIsStable$.subscribe(() => {
        console.log('check for updates');
        swUpdate.checkForUpdate();
        this.swUpdate.versionUpdates.subscribe(event => {
          if (event.type === "VERSION_READY") {
            console.log('there are updates');
            console.log(event);
            this.openModalConfirm('Nuova versione disponibile. procedere all\'aggiornamento?', 'doAppUpdate');
          }
          
        });
      });
    }
  }

  public checkForUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
      this.swUpdate.versionUpdates.subscribe(event => {
        if (event.type === "VERSION_READY") {
          console.log('there are updates');
          console.log(event);
          this.openModalConfirm('Nuova versione disponibile. procedere all\'aggiornamento?', 'doAppUpdate');
        }
      });
    }
  }


  openModalConfirm(message: string, callback: string, params?: any): void {
    if (window.confirm(message)) {
      this.doAppUpdate();
    }
  }

  doAppUpdate() {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }

}
